import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, arrayOf, shape } from 'prop-types'

import i18n from 'Pods/Shared/I18nHome'
import TrendingUpIcon from 'Pods/Shared/Icons/TrendingUpIcon'

const getTrackingAttributes = (button, index, trackingContext) => {
  if (!trackingContext) return {}

  return {
    'data-track': 'trending-click',
    'data-trending-keyword': button.name,
    'data-trending-context': trackingContext,
    'data-content-type': 'trending',
  }
}

function TrendingButtons({
  buttons,
  buttonType = '',
  buttonSize = 'small',
  customClass = '',
  trackingContext = null,
  locale = 'en',
}) {
  if (buttons.length === 0) { return null }

  const spanText = i18n.t('trendingSection.spanText', {
    ns: 'new-home',
    lng: locale,
  })
  return (
    <div className="trending-buttons">
      <span>{spanText}</span>
      {buttons.map((button, index) => (
        <Button
          key={index}
          href={button.url}
          type={buttonType}
          size={buttonSize}
          customClass={customClass}
          icon={<TrendingUpIcon width="16" height="16" />}
          aria-label={i18n.t('trendingSection.exploreAriaLabel', { name: button.name, ns: 'new-home', lng: locale })}
          {...getTrackingAttributes(button, index, trackingContext)}
        >
          {button?.name}
        </Button>
      ))}
    </div>
  )
}

TrendingButtons.propTypes = {
  buttons: arrayOf(
    shape({
      name: string,
      url: string,
    })
  ).isRequired,
  buttonType: string,
  buttonSize: string,
  customClass: string,
  trackingContext: string,
  locale: string,
}

TrendingButtons.displayName = 'TrendingButtons'

export default TrendingButtons
